import Proj5 from "../assets/proj5.jpg";
import Proj7 from "../assets/proj7.png";
import Proj8 from "../assets/proj8.png";
import PromptRootLogo from "../assets/PromptRootLogo.svg";
import SolmuLogo from "../assets/solmu.svg";

export const ProjectList = [
  {
    name: "CRM Data Platform & Analytics Integration",
    image: Proj8,
    type: "Data Platform",
    description: "Designed a PostgreSQL-based CRM data platform with Power BI analytics for a consulting practice, aligned with Salesforce data models to maintain CRM migration flexibility.",
    skills: "PostgreSQL, Supabase, Power BI, Salesforce, Data Modeling, CRM Data Architecture",
    githubUrl: "https://github.com/jessewashburn/consulting-crm-backend"
  },
  {
    name: "Tobii Eye-Tracking Data Pipeline",
    image: Proj7,
    type: "Data Pipeline",
    description: "Data analysis pipeline for Tobii eye-tracking research. Features R scripts for sequence and cluster analysis, Python machine learning models, Tableau-ready extracts, and automated CI schema validation. Co-authored findings for publication.",
    skills: "Python, R, Tableau, GitHub Actions, Data Visualization, Machine Learning",
    githubUrl: "https://github.com/jessewashburn/tobii-eye-tracking-pipeline"
  },
  {
    name: "PromptRoot",
    image: PromptRootLogo,
    type: "Web App",
    description: "An AI prompt coordination platform built for Open Learning Exchange that provides a single source of truth for AI-assisted development. Auto-syncs team prompts, handles batch submission to Jules API, and intelligently splits large prompts into subtasks, streamlining collaboration and eliminating manual coordination overhead for teams using AI in their DevOps workflows.",
    skills: "Docker, JavaScript, Firebase, GitHub API, GitHub Actions, Jules API, Markdown",
    githubUrl: "https://github.com/ole-vi/prompt-sharing",
    websiteUrl: "https://ole-vi.github.io/prompt-sharing/"
  },
  {
    name: "Solmu - Guitar Music Network",
    image: SolmuLogo,
    type: "Web App",
    description: "A comprehensive web application providing searchable access to over 74,000 classical guitar compositions spanning centuries of repertoire. Built with a Django REST Framework backend and React frontend, the database enables musicians, teachers, and researchers to explore works by instrumentation, composer nationality, composition period, and difficulty level. Features advanced Unicode-based title sorting, fuzzy search capabilities, and detailed metadata including catalog numbers, durations, and instrumentation details.",
    skills: "Django REST Framework, React, PostgreSQL, AWS Elastic Beanstalk, Supabase, Unicode Sorting, Fuzzy Search, IMSLP Data Aggregation",
    githubUrl: "https://github.com/jessewashburn/solmu",
    websiteUrl: "http://cgmd-frontend-1770139819.s3-website-us-east-1.amazonaws.com"
  },
  {
    name: "BMC Website",
    image: Proj5,
    type: "Website",
    description: "A modern, responsive website for Baltimore Metal Crafters built with Next.js 14, featuring a professional showcase of their metal restoration services, interactive gallery, and optimized SEO for local business presence since 1975.",
    skills: "Next.js 14, React, TypeScript, Tailwind CSS, Framer Motion, SEO Optimization",
    githubUrl: "https://github.com/jessewashburn/bmc_website",
    websiteUrl: "https://baltimoremetalcrafters.com"
  }
];
